import DeviceIcon from '../../common/icons/device';
import FolderIcon from '../../common/icons/folder';
import HomeIcon from '../../common/icons/home';
import QueueIcon from '../../common/icons/queue';
import ReviewIcon from '../../common/icons/review';
import TeamIcon from '../../common/icons/team';
import { ROUTES } from '../../core/constants/routes';

export const MENU = [
    { key: 'home', label: 'Inicio', shortLabel: 'Inicio', path: ROUTES.HOME, isPrimary: true, any: ['tasks:read', 'events:read'], Icon: HomeIcon },
    { key: 'projects', label: 'Proyectos', shortLabel: 'Proyectos', path: ROUTES.PROJECTS, domain: 'projects:read', Icon: FolderIcon },
    { key: 'work', label: 'Trabajo', shortLabel: 'Trabajo', path: ROUTES.WORK, isPrimary: true, domain: 'tasks:read', Icon: QueueIcon },
    { key: 'teams', label: 'Equipos', shortLabel: 'Equipos', path: ROUTES.TEAMS, domain: 'teams:read', Icon: TeamIcon },
    { key: 'reviews', label: 'Revisiones', shortLabel: 'Revisar', path: ROUTES.REVIEWS, isPrimary: true, domain: 'tasks:read', Icon: ReviewIcon },
    { key: 'device', label: 'Dispositivo y ajustes', shortLabel: 'Ajustes', path: ROUTES.DEVICE, Icon: DeviceIcon },
];

export const BOTTOM_NAV_MAX = 4;

// Builds a filtered array (not JSX), the sanctioned non-<Gate> use of can().
export function visibleMenu({ can, canAny }) {
    return MENU.filter((item) => {
        if (item.domain) return can(item.domain);
        if (item.any) return canAny(...item.any);
        return true;
    });
}

// The phone bar holds at most BOTTOM_NAV_MAX slots. When there are more
// sections, primary ones fill the bar and the last slot becomes "Más".
export function splitBottomNav(items, max = BOTTOM_NAV_MAX) {
    if (items.length <= max) return { primary: items, overflow: [] };
    const primary = items.filter((item) => item.isPrimary).slice(0, max - 1);
    for (const item of items) {
        if (primary.length >= max - 1) break;
        if (!primary.includes(item)) primary.push(item);
    }
    const ordered = items.filter((item) => primary.includes(item));
    return { primary: ordered, overflow: items.filter((item) => !primary.includes(item)) };
}
